
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS= "CHANGE_PASSWORD_SUCCESS"